<div class="main-content table-page table-page--compact clientes-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Clientes</h1>
        <p>Administre altas, cambios de estatus y la base comercial desde una sola vista.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button
          *ngIf="regresaPag"
          type="button"
          mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary"
          (click)="regresaProyectos()">
          <i class="material-icons">reply</i>
          <span>Regresar</span>
        </button>

        <button
          type="button"
          mat-raised-button
          class="btn table-page__primary-btn"
          (click)="agregarcliente()">
          <i class="material-icons">add</i>
          <span>Alta de Cliente</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar por razón social o RFC</mat-label>
          <input
            matInput
            aria-label="Buscar por razón social o RFC"
            type="text"
            maxlength="50"
            [ngModel]="searchTerm"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="filtroBusqueda($event)" />
        </mat-form-field>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaClientes.length > 0; else clientesEmptyState">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>RFC</th>
              <th>Contacto</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cliente of listaClientes">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ cliente.razonsocial }}</strong>
                  <span class="table-page__subtext">
                    {{ cliente.nombre_corto || "Sin nombre corto" }}
                    <ng-container *ngIf="cliente.idProyecto"> | {{ cliente.idProyecto }}</ng-container>
                  </span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ cliente.rfc || "Prospecto sin RFC" }}</span>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ cliente.nombreContacto || "Sin contacto" }}</span>
                  <span class="table-page__subtext">{{ cliente.email || "Sin correo" }}</span>
                </div>
              </td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(cliente)">
                  {{ getStatusLabel(cliente) }}
                </span>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="update(cliente)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="delete(cliente)">
                    <i class="material-icons">{{ cliente.estatus === "BAJA" ? "person_add_alt_1" : "person_off" }}</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #clientesEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else clientesLoadingState">
            <i class="material-icons">groups</i>
            <strong>No se encontraron clientes</strong>
            <span>Pruebe con otro criterio de búsqueda o registre un nuevo cliente desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #clientesLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando clientes...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} clientes</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else clientesPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #clientesPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
